/*
  FORZA 3.0 — YouTube lightbox (2026-10-02, owner: "clicking Factory tour should open the
  video in a YouTube iframe" instead of sending the visitor off the site).

  Markup contract — any link becomes a trigger:
    <a href="https://youtu.be/ID" target="_blank" data-frz-yt="ID" data-frz-yt-title="…">
  The href stays the no-JS fallback (and the ctrl/cmd/shift/middle-click "open in a new
  tab" path); a plain click, tap or Enter opens the modal instead. Used today by the
  Factory tour band on wheel/kit pages (snippets/forza-factory-tour.liquid) and on the
  home page (sections/video.liquid, full-bleed mode). Both load this file with defer;
  the guard below makes a second copy a no-op.

  Privacy/perf: the youtube-nocookie iframe is created ONLY on open, so the page fetches
  zero YouTube bytes until the click, and it is REMOVED on close, which stops the audio.
  The CSS is injected on first open as well — nothing here runs before a click except
  one delegated listener.

  Theme traps handled (forza-30-transfer gotchas):
  - The modal is appended to <body>: a transformed ancestor (frz-reveal entrance) would
    otherwise become the containing block of position:fixed ("lightbox shrank").
  - Backdrop closes only when the PRESS and the click both land outside the player
    (round 35 — a drag that ends on the overlay fires the click there).
  - iOS: html overflow:hidden alone leaks scroll chaining, so a non-passive touchmove
    preventDefault pins the background (touches inside the cross-origin iframe never
    reach this document, so the player itself keeps working).
  - BestChat's launcher sits at z-index max-int; html.frz-ytm-open hides it, the same
    remedy as html.frz-quote-open.
  - Full-HD body zoom: vw/vh are NOT rescaled by zoom, so the player size divides them
    by --frz-zoom (round 49). The overlay itself uses inset:0, which is zoom-proof.
  - The vanished classic scrollbar is compensated with body padding (quote-popup rule,
    owner round 33), divided by the zoom so the visual shift is exactly zero.
*/
(function () {
  'use strict';
  if (window.__frzYtModal) return;
  window.__frzYtModal = true;

  var CSS = [
    '.frz-ytm{position:fixed;inset:0;z-index:3141594;display:flex;align-items:center;justify-content:center;',
    'background:rgba(10,10,10,.92);opacity:0;transition:opacity .22s ease;overscroll-behavior:contain;',
    '-webkit-tap-highlight-color:transparent;cursor:default;',
    '--frz-ytm-vw:calc(100vw / var(--frz-zoom, 1));--frz-ytm-vh:calc(100vh / var(--frz-zoom, 1));--frz-ytm-gx:64px;--frz-ytm-gy:76px}',
    '@supports (height:100dvh){.frz-ytm{--frz-ytm-vh:calc(100dvh / var(--frz-zoom, 1))}}',
    '.frz-ytm[hidden]{display:none!important}',
    '.frz-ytm:focus{outline:none}',
    '.frz-ytm.is-open{opacity:1}',
    '.frz-ytm__box{position:relative;flex:none;aspect-ratio:16/9;background:#000;border-radius:0;',
    'width:min(calc(var(--frz-ytm-vw) - 2 * var(--frz-ytm-gx)), calc((var(--frz-ytm-vh) - 2 * var(--frz-ytm-gy)) * 16 / 9), 1600px);',
    'box-shadow:0 30px 90px rgba(0,0,0,.55)}',
    '.frz-ytm__box::before{content:"";position:absolute;left:50%;top:50%;width:34px;height:34px;margin:-17px 0 0 -17px;',
    'border:3px solid rgba(255,255,255,.16);border-top-color:#DD1D1D;border-radius:50%;animation:frz-ytm-spin .9s linear infinite}',
    '.frz-ytm.is-loaded .frz-ytm__box::before{display:none}',
    '@keyframes frz-ytm-spin{to{transform:rotate(360deg)}}',
    '.frz-ytm__player{position:absolute;inset:0;overflow:hidden}',
    '.frz-ytm .frz-ytm__player iframe{position:absolute;inset:0;width:100%!important;height:100%!important;max-width:none;border:0;margin:0;display:block;background:transparent}',
    '.frz-ytm .frz-ytm__close{position:absolute;right:0;bottom:100%;margin:0 0 14px;width:44px;height:44px;padding:0;',
    'display:flex;align-items:center;justify-content:center;border:1px solid rgba(255,255,255,.28)!important;border-radius:0!important;',
    'background:transparent!important;color:#FFFFFF!important;box-shadow:none!important;cursor:pointer;transition:background-color .15s ease,border-color .15s ease}',
    '@media (hover:hover){.frz-ytm .frz-ytm__close:hover{background:#DD1D1D!important;border-color:#DD1D1D!important}}',
    '.frz-ytm .frz-ytm__close:focus-visible{background:#DD1D1D!important;border-color:#DD1D1D!important}',
    '.frz-ytm .frz-ytm__close:focus-visible{outline:2px solid #FFFFFF;outline-offset:2px}',
    '.frz-ytm .frz-ytm__close svg{width:18px;height:18px;display:block;pointer-events:none}',
    '.frz-ytm__trap{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)}',
    /* phones, portrait: the film runs edge to edge, the x sits above its right corner */
    '@media (max-width:767px){.frz-ytm{--frz-ytm-gx:0px}.frz-ytm .frz-ytm__close{right:10px}}',
    /* short landscape screens (phones on their side): no room above, the x moves beside */
    '@media (orientation:landscape) and (max-height:540px){.frz-ytm{--frz-ytm-gx:64px;--frz-ytm-gy:12px}',
    '.frz-ytm .frz-ytm__close{bottom:auto;top:0;right:auto;left:100%;margin:0 0 0 10px}}',
    '@media (prefers-reduced-motion:reduce){.frz-ytm{transition:none}.frz-ytm__box::before{animation-duration:2.4s}}',
    'html.frz-ytm-open #bc-frame-container,html.frz-ytm-open #bc-livechat-container{display:none!important}'
  ].join('');

  var CLOSE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="2" stroke-linecap="square" fill="none"/></svg>';

  var modal = null, box = null, player = null, closeBtn = null;
  var opener = null, pausedVideo = null, hideTimer = null, pressOutside = false, isOpen = false;
  var locked = false, savedPad = '';

  function zoom() {
    var z = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--frz-zoom'));
    return z > 0 ? z : 1;
  }

  function lockScroll(on) {
    if (on === locked) return;
    locked = on;
    var html = document.documentElement, body = document.body;
    if (on) {
      var sbw = window.innerWidth - html.clientWidth;
      savedPad = body.style.paddingRight;
      html.style.overflow = 'hidden';
      if (sbw > 0) body.style.paddingRight = (sbw / zoom()) + 'px';
    } else {
      html.style.overflow = '';
      body.style.paddingRight = savedPad;
    }
  }

  function build() {
    var st = document.createElement('style');
    st.id = 'frz-ytm-css';
    st.textContent = CSS;
    document.head.appendChild(st);

    modal = document.createElement('div');
    modal.className = 'frz-ytm';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.tabIndex = -1;
    modal.innerHTML =
      '<span class="frz-ytm__trap" tabindex="0" data-trap="start"></span>' +
      '<div class="frz-ytm__box">' +
        '<button type="button" class="frz-ytm__close" aria-label="Close video">' + CLOSE_SVG + '</button>' +
        '<div class="frz-ytm__player"></div>' +
      '</div>' +
      '<span class="frz-ytm__trap" tabindex="0" data-trap="end"></span>';
    /* portal: a direct child of <body>, never inside the (possibly transformed) band */
    document.body.appendChild(modal);
    box = modal.querySelector('.frz-ytm__box');
    player = modal.querySelector('.frz-ytm__player');
    closeBtn = modal.querySelector('.frz-ytm__close');

    closeBtn.addEventListener('click', close);
    modal.addEventListener('pointerdown', function (e) { pressOutside = !box.contains(e.target); });
    modal.addEventListener('click', function (e) {
      if (pressOutside && !box.contains(e.target)) close();
      pressOutside = false;
    });
    modal.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
    modal.addEventListener('wheel', function (e) { e.preventDefault(); }, { passive: false });
    /* focus trap: Tab past the end wraps to the close button; Shift+Tab before the
       close button wraps to the player. Entering the start sentinel from the dialog
       itself (the first Tab after opening) is a forward move: close button. */
    modal.querySelectorAll('.frz-ytm__trap').forEach(function (t) {
      t.addEventListener('focus', function (e) {
        var f = player.querySelector('iframe');
        var back = t.getAttribute('data-trap') === 'start' && e.relatedTarget && box.contains(e.relatedTarget);
        if (back && f) f.focus();
        else closeBtn.focus({ preventScroll: true });
      });
    });
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    /* Tab / Shift+Tab straight from the dialog container: stay inside */
    if (e.key === 'Tab' && document.activeElement === modal) {
      e.preventDefault();
      var f = player.querySelector('iframe');
      (e.shiftKey && f ? f : closeBtn).focus({ preventScroll: true });
    }
  }

  function open(id, trigger) {
    if (!modal) build();
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    opener = trigger || null;
    var title = (trigger && trigger.getAttribute('data-frz-yt-title')) || 'Video';
    modal.setAttribute('aria-label', title + ' video');

    player.innerHTML = '';
    modal.classList.remove('is-loaded');
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0';
    f.title = title + ' — YouTube video player';
    f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    f.setAttribute('frameborder', '0');
    f.addEventListener('load', function () { modal.classList.add('is-loaded'); });
    player.appendChild(f);

    /* the band's own muted loop has nothing to show behind a dark overlay — pause it
       (saves CPU/data while the film plays) and resume it on close */
    pausedVideo = null;
    var band = trigger && trigger.closest('.forza-factour');
    var v = band && band.querySelector('video');
    if (v && !v.paused) { v.pause(); pausedVideo = v; }

    isOpen = true;
    modal.hidden = false;
    lockScroll(true);
    document.documentElement.classList.add('frz-ytm-open');
    document.addEventListener('keydown', onKey, true);
    /* double rAF so the fade runs from opacity 0; skipped if closed in between */
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      if (isOpen) modal.classList.add('is-open');
    }); });
    /* focus moves into the dialog itself, not onto the x: a programmatic focus on the
       button paints its focus-visible ring on touch devices (WebKit), which reads as a
       stuck pressed state. Tab from here reaches the x first; Esc works at once. */
    modal.focus({ preventScroll: true });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    /* drop the iframe first: that is what stops the sound, immediately */
    player.innerHTML = '';
    modal.classList.remove('is-open', 'is-loaded');
    document.documentElement.classList.remove('frz-ytm-open');
    document.removeEventListener('keydown', onKey, true);
    if (hideTimer) clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      modal.hidden = true;
      lockScroll(false);
      hideTimer = null;
    }, 230);
    if (pausedVideo) {
      var p = pausedVideo.play();
      if (p && p.catch) p.catch(function () {});
      pausedVideo = null;
    }
    if (opener && document.contains(opener)) {
      try { opener.focus({ preventScroll: true }); } catch (err) {}
    }
    opener = null;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[data-frz-yt]') : null;
    if (!a) return;
    var id = a.getAttribute('data-frz-yt') || '';
    if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    e.preventDefault();
    open(id, a);
  });

  window.FrzYtModal = { open: open, close: close };
})();
